import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SofboxModule } from '../lib/sofbox/components/sofbox/sofbox.module';
import { Error404Component } from './views/error404/error404.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ErrorInterceptor } from './interceptors/error-interceptor';
import { Error500Component } from './views/error500/error500.component';
import { Error403Component } from './views/error403/error403.component';
import { HeaderInterceptor } from './interceptors/header-interceptor';
import { AccountDisabledPageComponent } from './views/account-disabled-page/account-disabled-page.component';
import { NoAccessComponent } from './views/no-access/no-access.component';
import { SanitizerInterceptor } from './interceptors/sanitizer-interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { MatDialogModule } from '@angular/material/dialog';
import { TimeZoneModule } from './views/time-zone/time-zone.module';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { WithCredsInterceptor } from './interceptors/with-creds-interceptor';
import { I18N_VERSION } from '../environments/i18n-version';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '/assets/i18n/', `.json?v=${I18N_VERSION}`);
}

@NgModule({
  declarations: [
    AppComponent,
    Error404Component,
    Error500Component,
    Error403Component,
    AccountDisabledPageComponent,
    NoAccessComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'focusro-web-app' }),
    AppRoutingModule,
    HttpClientModule,
    SofboxModule,
    AlertModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    PopoverModule.forRoot(),
    ProgressbarModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    ButtonsModule.forRoot(),
    CarouselModule.forRoot(),
    NgScrollbarModule,
    NgxSliderModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    MatDialogModule,
    TimeZoneModule
  ],
  exports: [
    SofboxModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SanitizerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: WithCredsInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
